import axios from "./axios";

export const getSubscriptionPlans = () => axios.get("/subscriptions/plans");

export const getMySubscription = () => axios.get("/subscriptions/my");

export const checkJobPostEligibility = () => axios.get("/subscriptions/can-post-job");

export const createSubscriptionCheckout = (planId, couponCode) =>
  axios.post(`/subscriptions/plans/${planId}/checkout`, couponCode ? { couponCode } : {});

export const validateCoupon = (couponCode, subscriptionPlanId) =>
  axios.post("/subscriptions/coupon/validate", { couponCode, subscriptionPlanId });

export const cancelSubscription = () => axios.put("/subscriptions/cancel");

export const resumeSubscription = () => axios.put("/subscriptions/resume");

export const changePlan = (planId) =>
  axios.put("/subscriptions/change-plan", { planId });

export const getBillingPortal = () => axios.get("/subscriptions/billing-portal");